import { SpanContext } from '@opentelemetry/api';
import { SPAN_ID_BYTES } from './span-id-bytes.constant';
import { TRACE_ID_BYTES } from './trace-id-bytes.constant';

const LOWER_HEX_PATTERN = /^[0-9a-f]+$/;

export function isValidSpanContext(
  spanContext: SpanContext | undefined,
): spanContext is SpanContext {
  if (!spanContext) {
    return false;
  }

  return (
    isValidHexId(spanContext.traceId, TRACE_ID_BYTES) &&
    isValidHexId(spanContext.spanId, SPAN_ID_BYTES)
  );
}

function isValidHexId(id: string, byteLength: number): boolean {
  return (
    id.length === byteLength * 2 && LOWER_HEX_PATTERN.test(id) && !isAllZero(id)
  );
}

function isAllZero(id: string): boolean {
  return [...id].every((character) => character === '0');
}
